import { Box, Button, IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

import SearchBar from '../../components/SearchBar';
import TableComponent from '../../components/TableComponent';
import { showError, showToast } from '../../constants/toasts';
import { Loader } from '../../helpers';
import AddFaq from '../../Modals/addFaq';
import { ConfirmationModal } from '../../Modals/confirmationModal';
import { useLazyDeleteFaqQuery, useLazyGetFaqsQuery } from '../../service/cms';
import { FaqRes } from '../../types/General';
import { isValidInput } from '../../utils/validations';

const ManageFaq = () => {
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>('');
  const [selectedId, setSelectedId] = useState('');
  const [selectedFaq, setSelectedFaq] = useState<FaqRes | null>(null);
  const [openDelete, setOpenDelete] = useState(false);

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>, row: FaqRes) => {
    setAnchorEl1(event.currentTarget);
    setSelectedId(row?._id);
    setSelectedFaq(row);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
    // setSelectedId("");
    // setSelectedFaq(null);
  };

  const [count, setCount] = useState(0);
  const [faqs, setFaqs] = useState<FaqRes[]>([]);

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const [getFaqsList] = useLazyGetFaqsQuery();
  const [deleteFaq] = useLazyDeleteFaqQuery();

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const getFaqs = async () => {
    setLoading(true);
    try {
      const response = await getFaqsList({
        page: page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        setFaqs(response?.data?.faqs || []);
        setCount(response?.data?.count || 0);
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      const response = await deleteFaq({ id: selectedId }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        showToast('Deleted successfully');
        getFaqs();
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
      setLoading(false);
    }
  };

  const columns: GridColDef<(typeof faqs)[number]>[] = [
    {
      flex: 0.8,
      minWidth: 200,
      field: 'question',
      headerName: 'Question',
      sortable: false,
      filterable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <Tooltip title={row?.question}>
              <p>
                {row?.question?.length > 30
                  ? row?.question?.slice(0, 30) + '...'
                  : row?.question || '-'}
              </p>
            </Tooltip>
          </div>
        );
      },
    },

    {
      flex: 0.8,
      minWidth: 200,
      field: 'answer',
      headerName: 'Answer',
      sortable: false,
      filterable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <Tooltip title={row?.answer}>
              <p>
                {row?.answer?.length > 30 ? row?.answer?.slice(0, 30) + '...' : row?.answer || '-'}
              </p>
            </Tooltip>
          </div>
        );
      },
    },

    {
      flex: 0.8,
      minWidth: 200,
      field: 'date',
      headerName: 'Date',
      sortable: false,
      filterable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{moment(row?.createdAt).format('DD MMM YYYY')}</p>
          </div>
        );
      },
    },

    {
      flex: 0.1,
      minWidth: 80,
      field: 'action',
      headerName: 'Action',
      sortable: false,
      filterable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? 'basic-menu1' : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? 'true' : undefined}
                onClick={(event) => handleClick1(event, row)}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  'aria-labelledby': 'basic-button1',
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.05)',
                    borderRadius: '8px',
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <MenuItem
                  onClick={() => {
                    setOpenModal(true);
                    handleClose1();
                  }}
                >
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleClose1();
                    setOpenDelete(true);
                  }}
                >
                  Delete
                </MenuItem>
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    getFaqs();
  }, [debouncedSearchTerm, page]);

  return (
    <div>
      <Loader isLoad={loading} />

      <div className="main_title">
        <div className="cards">
          <Box className="custom_tabs" sx={{ width: '100%' }}>
            <div className="table_header">
              <div className="left_s">
                <Box className="search_box">
                  <SearchBar
                    searchTerm={searchTerm}
                    placeholder="Search"
                    setDebouncedSearchTerm={setDebouncedSearchTerm}
                    value={searchTerm}
                    onCross={() => setSearchTerm('')}
                    onChange={(val: any) => {
                      if (isValidInput(val.target.value)) {
                        setSearchTerm(val.target.value);
                      }
                    }}
                  />
                </Box>
              </div>
              <div className="right_s">
                <Box>
                  <Button
                    className="btn btn_orange"
                    onClick={() => {
                      setSelectedId('');
                      setSelectedFaq(null);
                      setOpenModal(true);
                    }}
                  >
                    Add faq
                  </Button>
                </Box>
              </div>
            </div>

            <TableComponent
              columns={columns}
              rows={faqs}
              count={count}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
            />
          </Box>
        </div>
      </div>
      <AddFaq
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
        getFaqs={getFaqs}
        selectedId={selectedId}
        selectedFaq={selectedFaq}
      />
      <ConfirmationModal
        text={'Are you sure to delete this FAQ?'}
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={handleDelete}
      />
    </div>
  );
};

export default ManageFaq;
